import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment} from "../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class UtenteService {

    private apiURL = environment.apiURL;

    constructor(private http: HttpClient) {}

    getUtente() {
        return this.http.get<any>(this.apiURL + '/user',  { withCredentials: true })
            .toPromise()
            .then(res => res)
            .then(data => data);
    }

}
